import React, { useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout';
import useSystemMasterList from '../../../../hooks/useSystemMasterList'
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import documentServices from '../documentServices';
import DocumentBarcodeComponent from '../components/DocumentBarcodeComponent';
import DocumentTimeline from '../components/DocumentTimeline';
import DocumentNoteForm from '../components/DocumentNoteForm';
import DocumentImageForm from '../components/DocumentImageForm';
import DocumentAttachmentForm from '../components/DocumentAttachmentForm';
import DocumentStatusUpdate from '../components/DocumentStatusUpdate';

function DocumentDetailsPage() {
    const {id} = useParams();
    const [masters,getMasterLabel] = useSystemMasterList(['department',"document-category","document-status","document-type"]);
    const [documentDetails,setDocumentDetails] = useState(null);
    const getDocumentDetails = () =>{
        setDocumentDetails(null);
        documentServices.getById(id).then(res=>{
            setDocumentDetails(res.data);
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getDocumentDetails();
    },[id])
    return (
        <AppLayout>
            <div className='container-fluid'>
            { documentDetails &&  masters &&
                <div className='row'>
                    <div className="col-md-3">
                        <ul class="list-group">
                            <li class="list-group-item bg-primary text-white">{documentDetails.title}</li>
                            <li class="list-group-item ">
                                <div className='border border-secondary p-3'>
                                {documentDetails.details}
                                </div>
                            </li>
                            <li class="list-group-item">Department  : {getMasterLabel("department", documentDetails.departmentId)}</li>
                            <li class="list-group-item">Category : {getMasterLabel("document-category", documentDetails.categoryId)}</li>
                            <li class="list-group-item">Document Type : {getMasterLabel("document-type", documentDetails.documentType)}</li>
                            <li class="list-group-item">Document Status {getMasterLabel("document-status", documentDetails.documentStatus)}</li>
                            <li class="list-group-item">Barcode : <DocumentBarcodeComponent documentDetails={documentDetails} onSuccess={getDocumentDetails} /> </li>
                        </ul>
                    </div>
                    <div className='col-md-9'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="border border-primary rounded my-2 p-2">
                                    <DocumentNoteForm documentId={documentDetails.id} onSuccess={getDocumentDetails} />
                                    <DocumentImageForm documentId={documentDetails.id} onSuccess={getDocumentDetails} />
                                    <DocumentAttachmentForm documentId={documentDetails.id} onSuccess={getDocumentDetails} />
                                    <DocumentStatusUpdate documentDetails={documentDetails} callBack={getDocumentDetails} />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                
                                <DocumentTimeline documentId={documentDetails.id} />
                            </div>
                        </div>
                        
                    </div>
                </div>
            }
            </div>
        </AppLayout>
    )
}

export default DocumentDetailsPage